import { boolean } from 'boolean';

import { ERHIntegrationType, EHRSystems } from 'constants/enums';

export const isGroupEHREnabled = (group?: IGroupInfo) => group && group.ehrSystem !== undefined;

export const isPatientEHREnabled = (patient?: IPatientState) =>
  patient?.data?.EHRIntegrationType !== undefined &&
  patient?.data?.EHRIntegrationType > ERHIntegrationType.NONE;

export const isEHRNotesEnabledForPatient = (patient?: IPatientState, group?: IGroupInfo) =>
  isPatientEHREnabled(patient) &&
  ((group?.ehrSystem === EHRSystems.EPIC &&
    group?.emrCSVersion !== undefined &&
    group?.emrCSVersion >= '2' &&
    group?.emrNotesEndpoint !== undefined) ||
    group?.ehrSystem === EHRSystems.NEXTGEN);

export const isEHRReportEnabled = (group?: IGroupInfo) =>
  isGroupEHREnabled(group) &&
  (group?.emrDisableManualReport === undefined || group?.emrDisableManualReport !== '1') &&
  group?.ehrSystem !== EHRSystems.GENERIC_3P;

export const isEHRAutomatedBillingEnabled = (group?: IGroupInfo) =>
  group?.billingEnabled === '1' && group?.ehrSystem === EHRSystems.EPIC;

export const isEHRInviteEnabled = (group?: IGroupInfo) =>
  group?.emrUseInvite === '1' && group?.ehrSystem === EHRSystems.EPIC;

export const isEpicToolboxGroup = (group?: IGroupInfo, org?: IGroupInfo) => {
  const ehrSystem = group?.ehrSystem ?? org?.ehrSystem;
  const emrBackendEnabled = group?.emrBackendEnabled ?? org?.emrBackendEnabled;
  return ehrSystem === EHRSystems.EPIC && boolean(emrBackendEnabled);
};
